import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_PORTAL_CLAIM_REQUEST: '',
  GET_PORTAL_CLAIM_SUCCESS: '',
  GET_PORTAL_CLAIM_FAILURE: '',
};

types = setStoreTypeValues(types, 'claimPortal');

export default types;
